import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { ApplicationService } from "../../../lib/services/application.service";
import { PwaInstallationService } from "../../../lib/sw/pwa-installation.service";

@Component({
    selector: 'app-scarica-app-section',
    styleUrls: ['../../../lib/themes/portale.theme.scss'],
    template: `
      <div class="portale-section portale-section--tint app-download-section">
        @if (showHeader) {
          <div class="section-title">
            <h2>Scarica l'app {{applicationService.getApplicationName()}}!</h2>
            <h4>Disponibile per iOS e Android.</h4>
          </div>
        }
        <div class="block-container">
          <div class="block app-download-section__store" (click)="pis.askToInstall()">
            <i class="fa-brands fa-apple"></i>
          </div>
          <div class="block app-download-section__store" (click)="pis.askToInstall()">
            <i class="fa-brands fa-android"></i>
          </div>
        </div>
      </div>
      `,
    styles: [
        `
      i.fa-brands {
        color: #216961;
        font-family: "Font Awesome 6 Brands" !important;
        font-size: 40px;
      }
      .app-download-section__store { cursor: pointer; }
      .app-download-section__store:hover { transform: translateY(-2px); }
      .app-download-section .block-container { flex-wrap: nowrap; gap: 20px; }
      .app-download-section .block-container .block { flex: 0 0 72px; }
      `
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ScaricaAppComponent {
  protected applicationService = inject(ApplicationService);
  protected pis = inject(PwaInstallationService);


  @Input() showHeader = true

  applicationName: string

}
